import React from 'react'

export function AboutIcon({ color = 'gray', width = 16, height = 16 }: any) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16">
      <path
        fill="#666666"
        d="M8.2,3.36c0.83,0,1.5-0.67,1.5-1.5s-0.67-1.5-1.5-1.5s-1.5,0.67-1.5,1.5S7.37,3.36,8.2,3.36z"
      />
      <path
        fill="#666666"
        d="M9.2,5.86c0-0.6-0.4-1-1-1h-3v2h2v6h-2v2h6v-2h-2V5.86z"
      />
    </svg>
  )
}

export function CompareArrows({
  color = 'gray',
  width = 16,
  height = 16,
}: any) {
  return (
    <svg
      width="16"
      style={{ transform: 'rotate(45deg)' }}
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 9.5L1.5 14.5M6.5 9.5L6.5 15.5M6.5 9.5H0.5M14.5 1.5L9.5 6.5M9.5 6.5H15.5M9.5 6.5V0.5"
        stroke="black"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function HighViewIcon({ color = 'gray', width = 16, height = 16 }: any) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 13.5001H9M1.5 14.0001V16.0001M7.5 14.0001V16.0001M12.5 7.0001V16.0001M1.5 7.5001H7.5V10.5001H1.5V7.5001ZM12.5 0.850098C12.9657 0.8502 13.4198 0.994775 13.7998 1.26388C14.1798 1.53299 14.467 1.91338 14.6217 2.35258C14.7764 2.79179 14.791 3.26817 14.6636 3.71604C14.5361 4.1639 14.2728 4.56119 13.91 4.8531C14.5005 5.16805 14.9687 5.67139 15.2402 6.28306C15.5117 6.89474 15.5708 7.57962 15.4083 8.2288C15.2457 8.87797 14.8708 9.45416 14.3431 9.86571C13.8154 10.2773 13.1652 10.5006 12.496 10.5001C11.8268 10.4996 11.1769 10.2754 10.6498 9.86309C10.1227 9.45079 9.74857 8.87407 9.58694 8.22467C9.42531 7.57526 9.48545 6.89046 9.7578 6.27917C10.0302 5.66788 10.4991 5.16521 11.09 4.8511C10.728 4.55898 10.4654 4.16183 10.3384 3.71433C10.2114 3.26683 10.2263 2.79097 10.3809 2.35225C10.5355 1.91353 10.8223 1.53351 11.2018 1.2645C11.5813 0.995488 12.0348 0.850712 12.5 0.850098Z"
        stroke="black"
      />
    </svg>
  )
}

export function DotMenu({ color = 'gray', width = 16, height = 16 }: any) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
        fill={color}
      />
      <path
        d="M2 10C3.10457 10 4 9.10457 4 8C4 6.89543 3.10457 6 2 6C0.89543 6 0 6.89543 0 8C0 9.10457 0.89543 10 2 10Z"
        fill={color}
      />
      <path
        d="M14 10C15.1046 10 16 9.10457 16 8C16 6.89543 15.1046 6 14 6C12.8954 6 12 6.89543 12 8C12 9.10457 12.8954 10 14 10Z"
        fill={color}
      />
    </svg>
  )
}
export function Download({ color = 'gray', width = 16, height = 16 }: any) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 14.5L5.5 13.5L0.5 15.5V2.5L5.5 0.5L10.5 2.5L15.5 0.5V8.5M12.5 8.5V15.5M12.5 15.5L15.5 12.5M12.5 15.5L9.5 12.5"
        stroke="#666666"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function DownloadPlan({ color = 'gray', width = 16, height = 16 }: any) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 15V16H0V15H15ZM8 0V10.293L12.5 5.79289L13.2071 6.5L7.5 12.2071L1.79289 6.5L2.5 5.79289L7 10.293V0H8Z"
        fill="black"
      />
    </svg>
  )
}

export function RightArrow({ color = 'gray', width = 16, height = 16 }: any) {
  return (
    <svg
      width="9"
      height="16"
      viewBox="0 0 9 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 0.5L8 8L0.5 15.5"
        stroke="#666666"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function LeftArrow({ color = 'gray', width = 16, height = 16 }: any) {
  return (
    <svg
      width="9"
      height="16"
      viewBox="0 0 9 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 0.5L1 8L8.5 15.5"
        stroke="#666666"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function Help({ color = 'gray', width = 16, height = 16 }: any) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00299 13C8.55528 13 9.00299 12.5523 9.00299 12C9.00299 11.4477 8.55528 11 8.00299 11C7.45071 11 7.00299 11.4477 7.00299 12C7.00299 12.5523 7.45071 13 8.00299 13Z"
        fill="#666666"
      />
      <path
        d="M6.83498 3.94821C7.19015 3.62769 7.79512 3.44685 8.35819 3.51354C8.9047 3.57827 9.3069 3.85493 9.44073 4.34398C9.54226 4.71218 9.49632 4.9476 9.39755 5.1482C9.28505 5.37669 9.09776 5.58185 8.82345 5.88233L8.79089 5.918C8.51542 6.21991 8.18474 6.59126 7.93001 7.08845C7.6712 7.59358 7.5 8.20836 7.5 9.00001C7.5 9.27615 7.72386 9.50001 8 9.50001C8.27614 9.50001 8.5 9.27615 8.5 9.00001C8.5 8.36265 8.63542 7.90468 8.81999 7.54444C9.00863 7.17626 9.25808 6.88961 9.52961 6.59202L9.59257 6.52325C9.83485 6.25906 10.1164 5.95203 10.2947 5.58994C10.5067 5.15928 10.5684 4.67215 10.4051 4.07956C10.1338 3.08894 9.30117 2.61823 8.47581 2.52048C7.66688 2.42467 6.76285 2.66632 6.16502 3.20581C5.96001 3.39081 5.9438 3.70698 6.1288 3.91198C6.3138 4.11699 6.62997 4.13321 6.83498 3.94821Z"
        fill="#666666"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1Z"
        fill="#666666"
      />
    </svg>
  )
}

export function Lock({ color = 'gray', width = 16, height = 16 }: any) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 7.5H2V15.5H14V7.5Z"
        stroke="black"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 12C8.55228 12 9 11.5523 9 11C9 10.4477 8.55228 10 8 10C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12Z"
        fill="black"
      />
      <path
        d="M12 7.5V4.5C12 3.43913 11.5786 2.42172 10.8284 1.67157C10.0783 0.921427 9.06087 0.5 8 0.5C6.93913 0.5 5.92172 0.921427 5.17157 1.67157C4.42143 2.42172 4 3.43913 4 4.5V7.5"
        stroke="black"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function FilterIcon({ color = 'gray', width = 16, height = 16 }: any) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 5.5H12.5M3.5 5.5H5.5M5.5 3.5V7.5M8 10.5H3.5M12.5 10.5H10.5M10.5 8.5V12.5M14.5 15.5H1.5C0.948 15.5 0.5 15.052 0.5 14.5V1.5C0.5 0.948 0.948 0.5 1.5 0.5H14.5C15.052 0.5 15.5 0.948 15.5 1.5V14.5C15.5 15.052 15.052 15.5 14.5 15.5Z"
        stroke={color}
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function PremiumCornerIcon({
  color = 'gray',
  width = 16,
  height = 16,
}: any) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 10.5H15.5M14.5 13.5H1.5C1.23478 13.5 0.98043 13.3946 0.792893 13.2071C0.605357 13.0196 0.5 12.7652 0.5 12.5V1.5L3.5 5.5L8 1.5L12.5 5.5L15.5 1.5V12.5C15.5 12.7652 15.3946 13.0196 15.2071 13.2071C15.0196 13.3946 14.7652 13.5 14.5 13.5Z"
        stroke="black"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function PremiumFloorIcon({
  color = 'gray',
  width = 16,
  height = 16,
}: any) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.5 0.5H11V4H7.5V7.5H4V10.5H0.5V15.5H15.5V0.5Z"
        stroke="black"
      />
    </svg>
  )
}

export function HighLightIcon({
  color = 'gray',
  width = 16,
  height = 16,
}: any) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 12.5C10.4853 12.5 12.5 10.4853 12.5 8C12.5 5.51472 10.4853 3.5 8 3.5C5.51472 3.5 3.5 5.51472 3.5 8C3.5 10.4853 5.51472 12.5 8 12.5Z"
        stroke="black"
      />
      <path d="M8 0V2" stroke="black" />
      <path d="M8 16V14" stroke="black" />
      <path d="M16 8H14" stroke="black" />
      <path d="M0 8H2" stroke="black" />
      <path d="M13.657 2.34302L12.243 3.75702" stroke="black" />
      <path d="M2.34299 13.6569L3.75699 12.2429" stroke="black" />
      <path d="M13.657 13.6569L12.243 12.2429" stroke="black" />
      <path d="M2.34299 2.34302L3.75699 3.75702" stroke="black" />
    </svg>
  )
}

export function InternalRoomsIcon({
  color = 'gray',
  width = 16,
  height = 16,
}: any) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 12.5H13.5V0.5H2.5M2.5 0.5V12.5L9.5 15.5V3.5L2.5 0.5Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function ExternalWindowIcon({
  color = 'gray',
  width = 16,
  height = 16,
}: any) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 6.5H1.5M8 0.5V12.5M4 2L3 3M5.75 2.75L3.75 4.75M1.5 0.5H14.5V12.5H1.5V0.5ZM0.5 15.5H15.5V12.5H0.5V15.5Z"
        stroke="black"
      />
    </svg>
  )
}

export function ObstructionIcon({
  color = 'gray',
  width = 16,
  height = 16,
}: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 9H0.5V3.5H2.5M2.5 9V14M2.5 9H13.5M13.5 9H15.5V3.5H13.5M13.5 9V14M2.5 3.5V1M2.5 3.5H13.5M13.5 3.5V1M4.11111 3.5L1 9.1M7.74074 3.5L4.62963 9.1M11.3704 3.5L8.25926 9.1M15 3.5L11.8889 9.1"
        stroke="black"
      />
    </svg>
  )
}

export function DrywallIcon({ color = 'gray', width = 16, height = 16 }: any) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 2.5H5M11 2.5H12M4 13.5H5M11 13.5H12M2.5 0.5L13.5 0.5V15.5H2.5V0.5Z"
        stroke="black"
      />
    </svg>
  )
}

export function LockIcon({ color = 'gray', width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 7.5H2V15.5H14V7.5Z"
        stroke={color}
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 12C8.55228 12 9 11.5523 9 11C9 10.4477 8.55228 10 8 10C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12Z"
        fill={color}
      />
      <path
        d="M12 7.5V4.5C12 3.43913 11.5786 2.42172 10.8284 1.67157C10.0783 0.921427 9.06087 0.5 8 0.5C6.93913 0.5 5.92172 0.921427 5.17157 1.67157C4.42143 2.42172 4 3.43913 4 4.5V7.5"
        stroke={color}
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
export function OutdoorTerraceIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.0888 0.855349C13.6243 0.526437 13.0692 0.349735 12.5001 0.349609C11.9316 0.350361 11.3765 0.527309 10.9126 0.856099C10.4488 1.18489 10.0983 1.64936 9.90931 2.18557C9.72034 2.72179 9.70221 3.3034 9.85742 3.85034C9.95177 4.18282 10.1073 4.49254 10.3142 4.76452C9.87892 5.11211 9.53031 5.56068 9.30107 6.0752C8.98333 6.78837 8.91316 7.58731 9.10173 8.34494C9.2903 9.10258 9.72678 9.77542 10.3418 10.2564C10.8255 10.6348 11.3978 10.8774 12 10.964V6.99963H13V10.9634C13.5992 10.8766 14.1686 10.6354 14.6506 10.2595C15.2662 9.77934 15.7036 9.10713 15.8933 8.34976C16.0829 7.59239 16.0139 6.79335 15.6972 6.07973C15.4687 5.56489 15.1207 5.11583 14.6859 4.76763C14.8935 4.49548 15.0497 4.18539 15.1444 3.85242C15.3002 3.30503 15.2824 2.72279 15.0933 2.18598C14.9042 1.64918 14.5532 1.18426 14.0888 0.855349ZM1 6.99963H8V10.9996H1V6.99963ZM1 13.9996H0V12.9996H9V13.9996H8V15.9996H7V13.9996H2V15.9996H1V13.9996ZM12 10.9996V15.9996H13V10.9996H12Z"
        fill={color}
      />
    </svg>
  )
}

export function HonestyMarketIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.4044 0H1.5956L0.0004942 3.83093L2.84191e-05 3.92964C-0.0026807 4.50378 0.188373 5.06205 0.542286 5.51415C0.8962 5.96625 1.39228 6.28574 1.95028 6.42094L1.95186 6.42132C2.81452 6.62738 3.7435 6.42678 4.36883 5.80289C4.86507 6.27818 5.55156 6.492 6.21402 6.492C6.88493 6.492 7.52847 6.27463 8.00002 5.8092C8.47157 6.27463 9.11512 6.492 9.78602 6.492C10.4485 6.492 11.135 6.27818 11.6312 5.80289C12.2565 6.42678 13.1855 6.62738 14.0482 6.42132L14.0498 6.42094C14.6078 6.28574 15.1038 5.96625 15.4578 5.51415C15.8117 5.06205 16.0027 4.50378 16 3.92964L15.9996 3.83093L14.4044 0ZM1.00003 8H15V16H1.00003V8ZM7.00003 11H9.00003V15H7.00003V11Z"
        fill={color}
      />
    </svg>
  )
}

export function RotateLeftIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 15.5C9.63 15.5 10.698 15.232 11.644 14.756M3.306 13.193C3.922 13.875 4.671 14.435 5.512 14.832M1.5 8.5C1.5 9.381 1.663 10.224 1.96 11M13.797 13.076C14.858 11.849 15.5 10.25 15.5 8.5C15.5 4.634 12.366 1.5 8.5 1.5C5.864 1.5 3.672 3.141 2.5 5.5M2.5 5.5V0.5M2.5 5.5H7.5"
        stroke={color}
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function RotateRightIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 15.5C6.37 15.5 5.302 15.232 4.356 14.756M12.694 13.193C12.078 13.875 11.329 14.435 10.488 14.832M14.5 8.5C14.5 9.381 14.337 10.224 14.04 11M2.203 13.076C1.142 11.849 0.5 10.25 0.5 8.5C0.5 4.634 3.634 1.5 7.5 1.5C10.136 1.5 12.328 3.141 13.5 5.5M13.5 5.5V0.5M13.5 5.5H8.5"
        stroke={color}
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function MapLegendIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 9.5V15.5M0.5 12.5H6.5M6.5 3.5C6.5 5.15685 5.15685 6.5 3.5 6.5C1.84315 6.5 0.5 5.15685 0.5 3.5C0.5 1.84315 1.84315 0.5 3.5 0.5C5.15685 0.5 6.5 1.84315 6.5 3.5ZM9.5 0.5H15.5V6.5H9.5V0.5ZM12.5 9.5L15.5 15.5H9.5L12.5 9.5Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function SidebarExtendIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 14.5L6.5 9.5M1.5 14.5L1.5 8.5M1.5 14.5L7.5 14.5M9.5 6.5L14.5 1.5M14.5 1.5L8.5 1.5M14.5 1.5V7.5"
        stroke="black"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function SidebarCollapseIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 9.5L1.5 14.5M6.5 9.5L6.5 15.5M6.5 9.5H0.5M14.5 1.5L9.5 6.5M9.5 6.5H15.5M9.5 6.5V0.5"
        stroke="black"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function RecenterIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 4.5V1.5C0.5 0.948 0.948 0.5 1.5 0.5H4.5M11.5 0.5H14.5C15.052 0.5 15.5 0.948 15.5 1.5V4.5M15.5 11.5V14.5C15.5 15.052 15.052 15.5 14.5 15.5H11.5M4.5 15.5H1.5C0.948 15.5 0.5 15.052 0.5 14.5V11.5M11.5 8C11.5 9.933 9.933 11.5 8 11.5C6.067 11.5 4.5 9.933 4.5 8C4.5 6.067 6.067 4.5 8 4.5C9.933 4.5 11.5 6.067 11.5 8Z"
        stroke="#666666"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export function RestRoomIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3333 30V22H18L20.6442 13.7755C21.1035 12.3471 21.4301 10.5088 22.8649 10.07C23.0107 10.0255 23.1668 10 23.3333 10C23.4999 10 23.656 10.0255 23.8018 10.07C25.2366 10.5088 25.5632 12.3471 26.0224 13.7755L28.6667 22H25.3333V30H21.3333Z"
        fill={color}
      />
      <path
        d="M26 4.66667C26 6.13943 24.8061 7.33333 23.3333 7.33333C21.8606 7.33333 20.6667 6.13943 20.6667 4.66667C20.6667 3.19391 21.8606 2 23.3333 2C24.8061 2 26 3.19391 26 4.66667Z"
        fill={color}
      />
      <path
        d="M12.6667 14V22H10.6667V30H6.66667V22H4.66667V14C4.66667 14 4.66667 10 8.66667 10C12.6667 10 12.6667 14 12.6667 14Z"
        fill={color}
      />
      <path
        d="M11.3333 4.66667C11.3333 6.13943 10.1394 7.33333 8.66667 7.33333C7.19391 7.33333 6 6.13943 6 4.66667C6 3.19391 7.19391 2 8.66667 2C10.1394 2 11.3333 3.19391 11.3333 4.66667Z"
        fill={color}
      />
      <path
        d="M21.3333 22V30H25.3333V22M21.3333 22H18L20.6442 13.7755C21.1035 12.3471 21.4301 10.5088 22.8649 10.07C23.0107 10.0255 23.1668 10 23.3333 10C23.4999 10 23.656 10.0255 23.8018 10.07C25.2366 10.5088 25.5632 12.3471 26.0225 13.7755L28.6667 22H25.3333M21.3333 22H25.3333M6.66667 22H4.66667V14C4.66667 14 4.66667 10 8.66667 10C12.6667 10 12.6667 14 12.6667 14V22H10.6667M6.66667 22V30H10.6667V22M6.66667 22H10.6667M26 4.66667C26 6.13943 24.8061 7.33333 23.3333 7.33333C21.8606 7.33333 20.6667 6.13943 20.6667 4.66667C20.6667 3.19391 21.8606 2 23.3333 2C24.8061 2 26 3.19391 26 4.66667ZM11.3333 4.66667C11.3333 6.13943 10.1394 7.33333 8.66667 7.33333C7.19391 7.33333 6 6.13943 6 4.66667C6 3.19391 7.19391 2 8.66667 2C10.1394 2 11.3333 3.19391 11.3333 4.66667Z"
        stroke={color}
      />
    </svg>
  )
}

export function MothersRoomIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.4142 0.585786C17.0391 0.210714 16.5304 0 16 0C15.4696 0 14.9609 0.210714 14.5858 0.585786C14.2107 0.960859 14 1.46957 14 2V4.66667C13.1907 5.27467 12.6667 6.24267 12.6667 7.33333H19.3333C19.3333 6.244 18.8107 5.276 18.0013 4.66667L18 2C18 1.46957 17.7893 0.960859 17.4142 0.585786ZM10.3905 9.05719C10.6406 8.80714 10.9797 8.66667 11.3333 8.66667H20.6667C21.0203 8.66667 21.3594 8.80714 21.6095 9.05719C21.8595 9.30724 22 9.64638 22 10V12H10V10C10 9.64638 10.1405 9.30724 10.3905 9.05719ZM7.72386 13.7239C7.97391 13.4738 8.31304 13.3333 8.66667 13.3333H23.3333C23.687 13.3333 24.0261 13.4738 24.2761 13.7239C24.5262 13.9739 24.6667 14.313 24.6667 14.6667V30.6667C24.6667 31.0203 24.5262 31.3594 24.2761 31.6095C24.0261 31.8595 23.687 32 23.3333 32H8.66667C8.31304 32 7.97391 31.8595 7.72386 31.6095C7.47381 31.3594 7.33333 31.0203 7.33333 30.6667V14.6667C7.33333 14.313 7.47381 13.9739 7.72386 13.7239ZM17.3333 20H22V18H17.3333V20ZM17.3333 24H22V22H17.3333V24ZM17.3333 28H22V26H17.3333V28Z"
        fill={color}
      />
    </svg>
  )
}
export function PrinterAlcoveIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.33333 6.66667V2H24.6667V6.66667"
        fill={color}
      />
      <path
        d="M7.33333 24.6667H2V11.3333C2 10.6261 2.28095 9.94781 2.78105 9.44772C3.28115 8.94762 3.95942 8.66667 4.66667 8.66667H27.3333C28.0406 8.66667 28.7189 8.94762 29.219 9.44772C29.719 9.94781 30 10.6261 30 11.3333V24.6667H24.6667V16.6667H7.33333V24.6667Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.33333 18.6667H22.6667V29.3333H9.33333V18.6667Z"
        fill={color}
      />
    </svg>
  )
}

export function LobbyIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.5 15.5L0.5 12.5V0.5L7.5 3.5V15.5Z" fill={color} />
      <path
        d="M9.5 12.5H11.5V0.5H0.5M0.5 0.5V12.5L7.5 15.5V3.5L0.5 0.5Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
export function CommunityBarIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2547 6.72583C19.2849 6.25082 20 5.20892 20 4C20 2.34315 18.6569 1 17 1C15.3431 1 14 2.34315 14 4C14 5.20892 14.7151 6.25082 15.7453 6.72583C14.1508 7.31791 13 9.00776 13 11H21C21 9.00776 19.8492 7.31791 18.2547 6.72583Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4 8.5C3.72386 8.5 3.5 8.72386 3.5 9V12H2V23H22V12H9.5V9C9.5 8.72386 9.27614 8.5 9 8.5H4ZM4 20H20V21H4V20ZM20 17H4V18H20V17ZM4 14H20V15H4V14Z"
        fill={color}
      />
    </svg>
  )
}
export function PhoneBoothIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4112 18.914L17.5565 21.73C16.0678 20.8324 14.6849 19.7702 13.4338 18.5633C12.2288 17.3101 11.1668 15.927 10.2672 14.4393L13.0805 11.5846C13.2509 11.4116 13.366 11.1918 13.4111 10.9532C13.4562 10.7146 13.4293 10.4679 13.3338 10.2446L10.4005 3.40732C10.2846 3.13771 10.0757 2.91872 9.81191 2.79023C9.54808 2.66175 9.24688 2.63232 8.96317 2.70732L3.5845 4.12998C3.3159 4.19961 3.07889 4.35835 2.91224 4.58022C2.7456 4.80209 2.6592 5.07395 2.66717 5.35132C3.00941 11.607 5.61044 17.5259 9.98717 22.0087C14.4707 26.3868 20.3912 28.9883 26.6485 29.33C26.9261 29.3393 27.1986 29.2536 27.421 29.0871C27.6433 28.9205 27.8021 28.6831 27.8712 28.414L29.2925 23.0326C29.3679 22.7491 29.3388 22.4479 29.2105 22.184C29.0822 21.9202 28.8634 21.7112 28.5938 21.5953L21.7552 18.6633C21.5317 18.5665 21.2843 18.5386 21.0449 18.5832C20.8054 18.6279 20.5847 18.7431 20.4112 18.914Z"
        fill={color}
      />
    </svg>
  )
}

export function StairsIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M28.6667 3.33334H22V8.66668H16.6667V15.3333H10V22H3.33333V28.6667H28.6667V3.33334Z"
        fill={color}
      />
    </svg>
  )
}

export function WellnessRoomIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2572 25.2587C11.1876 21.8386 9.6171 18.0318 9.6171 13.8496C9.6171 13.5896 9.62318 13.3311 9.6353 13.074C7.46716 11.7289 4.87294 11.0202 1.81921 10.9846C1.86535 15.3078 3.19906 18.7359 5.77155 21.3398C8.04566 23.642 10.4737 24.9473 14.2572 25.2587Z"
        fill={color}
      />
      <path
        d="M16.0001 2.66666C12.6624 6.06488 11.0355 9.78827 11.0355 13.8496C11.0355 17.9122 12.6623 21.6344 16.0001 25.0325C19.3399 21.6346 20.9644 17.9125 20.9644 13.8496C20.9644 9.788 19.3399 6.06467 16.0001 2.66666Z"
        fill={color}
      />
      <path
        d="M22.3645 13.0714C22.3767 13.3293 22.3828 13.5887 22.3828 13.8496C22.3828 18.0309 20.8152 21.8372 17.745 25.257C21.5261 24.9453 23.9545 23.6401 26.2268 21.3385C28.8004 18.7347 30.1345 15.3064 30.1831 10.9832C27.1271 11.0187 24.5327 11.7274 22.3645 13.0714Z"
        fill={color}
      />
      <path
        d="M26.8297 22.7461C24.3673 25.1007 21.634 26.4238 17.5901 26.7064C19.1388 28.1469 20.8411 28.9844 22.7023 29.2463C25.4177 29.6302 28.0636 28.7503 30.6667 26.4778C29.4955 24.8013 28.2125 23.5714 26.8297 22.7461Z"
        fill={color}
      />
      <path
        d="M14.4081 26.7077C10.3635 26.4248 7.63131 25.1015 5.16807 22.7467C3.78604 23.572 2.50425 24.8022 1.33334 26.4767C3.93633 28.7504 6.5823 29.6302 9.29767 29.2463C11.1585 28.9834 12.86 28.1469 14.4081 26.7077Z"
        fill={color}
      />
    </svg>
  )
}

export function ConferenceRoomsIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.66667 1.33334H30.6667V21.3333H13.2C12.7686 19.208 11.3261 17.4499 9.39649 16.5827C10.9557 15.6519 12 13.9479 12 12C12 9.05449 9.61219 6.66668 6.66667 6.66668V1.33334ZM14.6667 12H16.6667V16H14.6667V12ZM20 6.66668H18V16H20V6.66668ZM24.6667 8.00001H26.6667V16H24.6667V8.00001ZM23.3333 10.6667H21.3333V16H23.3333V10.6667Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.66667 12C2.66667 9.79087 4.45753 8.00001 6.66667 8.00001C8.87581 8.00001 10.6667 9.79087 10.6667 12C10.6667 14.2091 8.87581 16 6.66667 16C4.45753 16 2.66667 14.2091 2.66667 12ZM2.89543 18.8954C3.89563 17.8952 5.25218 17.3333 6.66667 17.3333C8.08116 17.3333 9.43771 17.8952 10.4379 18.8954C11.4381 19.8956 12 21.2522 12 22.6667V30.6667H1.33334V22.6667C1.33334 21.2522 1.89524 19.8956 2.89543 18.8954Z"
        fill={color}
      />
    </svg>
  )
}

export function KitchenIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 27.3333C7.33333 27.3333 2 22 2 15.3333V11.3333H26V15.3333C26 22 20.6667 27.3333 14 27.3333Z"
        fill={color}
      />
      <path
        d="M31.3333 11.3333H31.8333V10.8333H31.3333V11.3333ZM2 11.3333V10.8333H1.5V11.3333H2ZM26 11.8333H31.3333V10.8333H26V11.8333ZM30.8333 11.3333V16.6667H31.8333V11.3333H30.8333ZM30.8333 16.6667C30.8333 17.8572 29.8572 18.8333 28.6667 18.8333V19.8333C30.4095 19.8333 31.8333 18.4095 31.8333 16.6667H30.8333ZM28.6667 18.8333H25.3333V19.8333H28.6667V18.8333ZM14 26.8333C7.60948 26.8333 2.5 21.7239 2.5 15.3333H1.5C1.5 22.2761 7.05719 27.8333 14 27.8333V26.8333ZM2.5 15.3333V11.3333H1.5V15.3333H2.5ZM2 11.8333H26V10.8333H2V11.8333ZM25.5 11.3333V15.3333H26.5V11.3333H25.5ZM25.5 15.3333C25.5 21.7239 20.3905 26.8333 14 26.8333V27.8333C20.9428 27.8333 26.5 22.2761 26.5 15.3333H25.5ZM2 31.8333H26V30.8333H2V31.8333ZM6.83333 2.66667L6.83333 6.66667H7.83333L7.83333 2.66667H6.83333ZM13.5 1.33333V5.33333H14.5V1.33333H13.5ZM20.1667 2.66667V6.66667H21.1667V2.66667H20.1667Z"
        fill={color}
      />
    </svg>
  )
}
export function HotDeskIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.33334 8C5.33334 5.79086 7.1242 4 9.33334 4C11.5425 4 13.3333 5.79086 13.3333 8C13.3333 10.2091 11.5425 12 9.33334 12C7.1242 12 5.33334 10.2091 5.33334 8ZM2.70017 14.7002C3.57534 13.825 4.76233 13.3333 6 13.3333C8.20277 13.3333 9.63147 14.5332 10.8076 15.713C11.014 15.92 11.2081 16.1214 11.3967 16.3171C11.7655 16.6999 12.1133 17.0609 12.4911 17.3993C13.0453 17.8957 13.596 18.2764 14.2141 18.486L14.998 18.7518L12.92 22.2054L10.6667 21.0787V28H1.33334V18C1.33334 16.7623 1.825 15.5753 2.70017 14.7002ZM20.1277 14.6667H30.8247L28.5389 25.3333H13.3333V24H18.1277L20.1277 14.6667Z"
        fill={color}
      />
    </svg>
  )
}

export function GameRoomIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.33333 26H28.6667V31.3333H3.33333V26Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.66667 26C9.456 19.2493 16.5173 17.6267 14 11.3333L7.33333 12.6667L6 10L11.3333 4.66667V2C17.0107 2 22.2453 4.864 24.6667 10C26.8573 14.6453 26.1067 21.768 23.3333 26"
        fill={color}
      />
    </svg>
  )
}

export function ElevatorFoyerIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.42857 0.666656C6.63959 0.666656 6 1.26361 6 1.99999V30C6 30.7364 6.63959 31.3333 7.42857 31.3333H24.5714C25.3604 31.3333 26 30.7364 26 30V1.99999C26 1.26361 25.3604 0.666656 24.5714 0.666656H7.42857ZM16 5.33332L10.2857 14L21.7143 14L16 5.33332ZM21.7143 18L16 26.6667L10.2857 18L21.7143 18Z"
        fill={color}
      />
    </svg>
  )
}

export function OfficeIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 8.66666H30V4.66666H2V28V8.66666Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30 7.99999V28V7.99999Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30 16.6667H15.3333H30Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20 12.6667H25.3333H20Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.3333 8.66666V28V8.66666Z"
        fill={color}
      />
      <path
        d="M30 7.99999V28M30 16.6667H15.3333M20 12.6667H25.3333M15.3333 8.66666V28M2 8.66666H30V4.66666H2V28V8.66666Z"
        stroke="white"
      />
    </svg>
  )
}

export function ShowersIcon({ color, width = 16, height = 16 }: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.1567 1.33333C16.6478 1.33487 15.1665 1.73816 13.8651 2.50177C12.6748 3.20018 11.6742 4.17695 10.9479 5.34588C7.79071 5.55228 5.33333 8.27677 5.33333 11.556V13.3333H17.3333V11.556C17.3333 8.55166 15.2707 6.01295 12.497 5.44972C13.0548 4.72793 13.7475 4.11669 14.5398 3.65176C15.6369 3.00803 16.8856 2.66802 18.1577 2.66666C22.1169 2.66684 25.3333 5.89987 25.3333 9.89733V30.6667H26.6667V9.89733C26.6667 5.17223 22.8612 1.33333 18.1567 1.33333ZM6.66667 11.556C6.66667 8.82886 8.78032 6.66666 11.3333 6.66666C13.8863 6.66666 16 8.82886 16 11.556V12H6.66667V11.556Z"
        fill={color}
      />
      <path d="M16 20V16H17.3333V20H16Z" fill={color} />
      <path d="M10.6667 16V20H12V16H10.6667Z" fill={color} />
      <path d="M5.33333 20V16H6.66667V20H5.33333Z" fill={color} />
      <path d="M8 21.3333V25.3333H9.33333V21.3333H8Z" fill={color} />
      <path
        d="M13.3333 25.3333V21.3333H14.6667V25.3333H13.3333Z"
        fill={color}
      />
      <path d="M16 26.6667V30.6667H17.3333V26.6667H16Z" fill={color} />
      <path d="M10.6667 30.6667V26.6667H12V30.6667H10.6667Z" fill={color} />
      <path
        d="M5.33333 26.6667V30.6667H6.66667V26.6667H5.33333Z"
        fill={color}
      />
      <path
        d="M11.3333 6.66666C8.78032 6.66666 6.66667 8.82886 6.66667 11.556V12H16V11.556C16 8.82886 13.8863 6.66666 11.3333 6.66666Z"
        fill={color}
      />
    </svg>
  )
}

export function CapacityIcon({
  color = '#000000',
  width = 12,
  height = 12,
}: any) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.625 11.625C0.625 11.9011 0.848858 12.125 1.125 12.125C1.40114 12.125 1.625 11.9011 1.625 11.625H0.625ZM10.375 11.625C10.375 11.9011 10.5989 12.125 10.875 12.125C11.1511 12.125 11.375 11.9011 11.375 11.625H10.375ZM1.625 11.625V11.1877H0.625V11.625H1.625ZM1.625 11.1877C1.625 8.81192 3.57757 6.875 6 6.875V5.875C3.03743 5.875 0.625 8.24758 0.625 11.1877H1.625ZM6 6.875C8.42243 6.875 10.375 8.81192 10.375 11.1877H11.375C11.375 8.24758 8.96257 5.875 6 5.875V6.875ZM10.375 11.1877V11.625H11.375V11.1877H10.375ZM8.5 3.375C8.5 4.75571 7.38071 5.875 6 5.875V6.875C7.933 6.875 9.5 5.308 9.5 3.375H8.5ZM6 5.875C4.61929 5.875 3.5 4.75571 3.5 3.375H2.5C2.5 5.308 4.067 6.875 6 6.875V5.875ZM3.5 3.375C3.5 1.99429 4.61929 0.875 6 0.875V-0.125C4.067 -0.125 2.5 1.442 2.5 3.375H3.5ZM6 0.875C7.38071 0.875 8.5 1.99429 8.5 3.375H9.5C9.5 1.442 7.933 -0.125 6 -0.125V0.875Z"
        fill="black"
      />
    </svg>
  )
}

export function NoteIcon() {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 12.84H12V0.84H0V12.84Z" fill="url(#pattern0)" />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use href="#image0" transform="scale(0.015625)" />
        </pattern>
        <image
          id="image0"
          width="64"
          height="64"
          href="data:image/png;base64,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"
        />
      </defs>
    </svg>
  )
}

export const CalendarIcon = ({ color, width = 16, height = 16 }: any) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 5.5H14.5M3.5 0.5V2.5M11.5 0.5V2.5M7.5 0.5V2.5M13.5 2.5H1.5C0.948 2.5 0.5 2.948 0.5 3.5V14.5C0.5 15.052 0.948 15.5 1.5 15.5H13.5C14.052 15.5 14.5 15.052 14.5 14.5V3.5C14.5 2.948 14.052 2.5 13.5 2.5Z"
      stroke="black"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export const BookIcon = ({ color, width = 16, height = 16 }: any) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 5.5V6C0.5 7.381 2.962 8.5 6 8.5C9.038 8.5 11.5 7.381 11.5 6V5.5M0.5 8.5V9C0.5 10.381 2.962 11.5 6 11.5C9.038 11.5 11.5 10.381 11.5 9V8.5M0.5 11.5V12C0.5 13.381 2.962 14.5 6 14.5C9.038 14.5 11.5 13.381 11.5 12V11.5M11.5 3C11.5 4.38071 9.03757 5.5 6 5.5C2.96243 5.5 0.5 4.38071 0.5 3C0.5 1.61929 2.96243 0.5 6 0.5C9.03757 0.5 11.5 1.61929 11.5 3Z"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export const ScheduleIcon = ({ color, width = 16, height = 16 }: any) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 11.5H15.5V0.5H3.5V2M10.5 3V9M12.5 5V9M8.5 6V9M5 5.5C5 6.60457 4.10457 7.5 3 7.5C1.89543 7.5 1 6.60457 1 5.5C1 4.39543 1.89543 3.5 3 3.5C4.10457 3.5 5 4.39543 5 5.5ZM3 9.5C3.66304 9.5 4.29893 9.76339 4.76777 10.2322C5.23661 10.7011 5.5 11.337 5.5 12V15.5H0.5V12C0.5 11.337 0.763392 10.7011 1.23223 10.2322C1.70107 9.76339 2.33696 9.5 3 9.5Z"
      stroke="black"
    />
  </svg>
)

export const EditIcon = ({ color, width = 16, height = 16 }: any) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 15.5H15M8.5 2.5L11.5 5.5M10.5 0.5L13.5 3.5L5 12L1 13L2 9L10.5 0.5Z"
      stroke="white"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export const SpaceIcon = ({ color, width = 16, height = 16 }: any) => (
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5 12.5H11.5V0.5H0.5M0.5 0.5V12.5L7.5 15.5V3.5L0.5 0.5Z"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export const ProductIcon = ({ color, width = 16, height = 16 }: any) => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 9.379C5.78 8.816 5.076 6.5 2.833 6.5C1.545 6.5 0.5 7.507 0.5 8.75V13.5H4.5V11M6 12.5H10M10 12.5H14L15 7.5H11L10 12.5ZM6.5 2.5C6.5 3.60457 5.60457 4.5 4.5 4.5C3.39543 4.5 2.5 3.60457 2.5 2.5C2.5 1.39543 3.39543 0.5 4.5 0.5C5.60457 0.5 6.5 1.39543 6.5 2.5Z"
      stroke="black"
    />
  </svg>
)

export const CommonAreasIcon = ({ color, width = 16, height = 16 }: any) => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 7.5V8H13V7.5H12.5ZM3.5 7.5H3V8H3.5V7.5ZM0.5 5H0H0.5ZM0.5 11H0H0.5ZM2 0.5V0V0.5ZM14 0.5V0V0.5ZM16 11V5H15V11H16ZM16 5C16 4.73478 15.8946 4.48043 15.7071 4.29289L15 5H16ZM15.7071 4.29289C15.5196 4.10536 15.2652 4 15 4V5L15.7071 4.29289ZM15 4H13V5H15V4ZM13 4C12.7348 4 12.4804 4.10536 12.2929 4.29289L13 5V4ZM12.2929 4.29289C12.1054 4.48043 12 4.73478 12 5H13L12.2929 4.29289ZM12 5V7.5H13V5H12ZM12.5 7H3.5V8H12.5V7ZM4 7.5V5H3V7.5H4ZM4 5C4 4.73478 3.89464 4.48043 3.70711 4.29289L3 5H4ZM3.70711 4.29289C3.51957 4.10536 3.26522 4 3 4V5L3.70711 4.29289ZM3 4H1V5H3V4ZM1 4C0.734783 4 0.480429 4.10536 0.292893 4.29289L1 5H1V4ZM0.292893 4.29289C0.105357 4.48043 0 4.73478 0 5H1H1L0.292893 4.29289ZM0 5V11H1V5H0ZM0 11C0 11.2652 0.105356 11.5196 0.292893 11.7071L1 11H1H0ZM0.292893 11.7071C0.48043 11.8946 0.734784 12 1 12V11H1L0.292893 11.7071ZM1 12H15V11H1V12ZM15 12C15.2652 12 15.5196 11.8946 15.7071 11.7071L15 11V12ZM15.7071 11.7071C15.8946 11.5196 16 11.2652 16 11H15L15.7071 11.7071ZM2 4.5V1H1V4.5H2ZM2 1V1L1.29289 0.292893C1.10536 0.48043 1 0.734784 1 1H2ZM2 1V1V0C1.73478 0 1.48043 0.105357 1.29289 0.292893L2 1ZM2 1H14V0H2V1ZM14 1V1L14.7071 0.292893C14.5196 0.105356 14.2652 0 14 0V1ZM14 1V1H15C15 0.734784 14.8946 0.48043 14.7071 0.292893L14 1ZM14 1V4.5H15V1H14ZM8.5 7V0.5H7.5V7H8.5ZM3 14V12H2V14H3ZM14 14V12H13V14H14Z"
      fill="black"
    />
  </svg>
)

export const NooksIcon = ({ color, width = 16, height = 16 }: any) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.506225 16L0.50625 8C0.50625 8 0.0042168 0.5 7.99887 0.5C15.9935 0.5 15.4938 8 15.4938 8V16M2.50256 16V12.5M2.50256 12.5V8M2.50256 12.5H4.75105C5.16498 12.5 5.50055 12.8256 5.50055 13.2273V16M13.4952 16V12.5M13.4952 12.5V8M13.4952 12.5H11.2467C10.8327 12.5 10.4972 12.8256 10.4972 13.2273V16M7.99886 16V10.5M7.99886 10.5H5.00088M7.99886 10.5H10.9968"
      stroke="black"
    />
  </svg>
)

export const RestRoomBorderedIcon = ({
  color,
  width = 16,
  height = 16,
}: any) => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 11.5V15.5H12V11.5M10 11.5H8L9.5 6.5C9.75403 5.72601 9.94315 4.5 11 4.5C12.0568 4.5 12.246 5.72601 12.5 6.5L14 11.5H12M10 11.5H12M2 11.5H0.5V7.00001C0.5 7.00001 0.5 4.50001 3 4.50001C5.5 4.50001 5.5 7.00001 5.5 7.00001V11.5H4M2 11.5V15.5H4V11.5M2 11.5H4M4.5 1.99905C4.5 2.84063 3.85911 3.50001 3 3.50001C2.14089 3.50001 1.5 2.84063 1.5 1.99905C1.5 1.15748 2.14089 0.500008 3 0.500008C3.85911 0.500008 4.5 1.15748 4.5 1.99905ZM12.5 1.99905C12.5 2.84062 11.8591 3.5 11 3.5C10.1409 3.5 9.5 2.84062 9.5 1.99905C9.5 1.15747 10.1409 0.5 11 0.5C11.8591 0.5 12.5 1.15747 12.5 1.99905Z"
      stroke="black"
    />
  </svg>
)

export const KitchenBorderedIcon = ({
  color,
  width = 16,
  height = 16,
}: any) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 5.5V5C2.22386 5 2 5.22386 2 5.5H2.5ZM12.5 8.5H13H12.5ZM7.5 13.5V14V13.5ZM8 0.5V0H7V0.5H8ZM7 2.5V3H8V2.5H7ZM5 0.5V0H4V0.5H5ZM4 2.5V3H5V2.5H4ZM11 0.5V0H10V0.5H11ZM10 2.5V3H11V2.5H10ZM12.5 9C12.2239 9 12 9.22386 12 9.5C12 9.77614 12.2239 10 12.5 10V9ZM15.5 5.5H16C16 5.22386 15.7761 5 15.5 5V5.5ZM14.5 16C14.7761 16 15 15.7761 15 15.5C15 15.2239 14.7761 15 14.5 15V16ZM0.5 15C0.223858 15 0 15.2239 0 15.5C0 15.7761 0.223858 16 0.5 16V15ZM2.5 6H12.5V5H2.5V6ZM12 5.5V8.5H13V5.5H12ZM12 8.5C12 9.69347 11.5259 10.8381 10.682 11.682L11.3891 12.3891C12.4205 11.3576 13 9.95869 13 8.5H12ZM10.682 11.682C9.83807 12.5259 8.69347 13 7.5 13V14C8.95869 14 10.3576 13.4205 11.3891 12.3891L10.682 11.682ZM7.5 13C6.30653 13 5.16193 12.5259 4.31802 11.682L3.61091 12.3891C4.64236 13.4205 6.04131 14 7.5 14V13ZM4.31802 11.682C3.47411 10.8381 3 9.69347 3 8.5H2C2 9.95869 2.57946 11.3576 3.61091 12.3891L4.31802 11.682ZM3 8.5V5.5H2V8.5H3ZM7 0.5V2.5H8V0.5H7ZM4 0.5V2.5H5V0.5H4ZM10 0.5V2.5H11V0.5H10ZM12.5 10H13.5V9H12.5V10ZM13.5 10C14.163 10 14.7989 9.73661 15.2678 9.26777L14.5607 8.56066C14.2794 8.84196 13.8978 9 13.5 9V10ZM15.2678 9.26777C15.7366 8.79893 16 8.16304 16 7.5H15C15 7.89782 14.842 8.27936 14.5607 8.56066L15.2678 9.26777ZM16 7.5V5.5H15V7.5H16ZM15.5 5H12.5V6H15.5V5ZM14.5 15H0.5V16H14.5V15Z"
      fill="black"
    />
  </svg>
)

export const PrinterAlcoveBorderedIcon = ({
  color,
  width = 16,
  height = 16,
}: any) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 2V0.5H12.5V2M3.808 12.5H0.5V5.833C0.5 5.097 1.14 4.5 1.929 4.5H14.07C14.86 4.5 15.499 5.097 15.499 5.833V12.5H12.191M3.5 8.5H12.5V15.5H3.5V8.5Z"
      stroke="black"
    />
  </svg>
)

export const PhoneBoothBorderedIcon = ({
  color,
  width = 16,
  height = 16,
}: any) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0137 10.2635L9.79171 11.7915C7.89815 10.6789 6.32025 9.10103 5.20771 7.20747L6.73571 5.98547C6.91483 5.84213 7.04142 5.64349 7.0957 5.4206C7.14997 5.1977 7.12888 4.96311 7.03571 4.75347L5.64271 1.61647C5.54282 1.39167 5.36633 1.20966 5.14472 1.10288C4.92311 0.996108 4.67078 0.971507 4.43271 1.03347L1.78071 1.72047C1.53335 1.78532 1.31832 1.93855 1.17626 2.15118C1.0342 2.36381 0.974949 2.62112 1.00971 2.87447C1.47501 6.18821 3.00649 9.26038 5.37265 11.6265C7.7388 13.9927 10.811 15.5242 14.1247 15.9895C14.378 16.0244 14.6352 15.9652 14.8478 15.8231C15.0603 15.681 15.2133 15.4659 15.2777 15.2185L15.9657 12.5675C16.0277 12.3294 16.0031 12.0771 15.8963 11.8555C15.7895 11.6339 15.6075 11.4574 15.3827 11.3575L12.2457 9.96447C12.0361 9.87154 11.8017 9.85047 11.5789 9.90454C11.3561 9.95862 11.1574 10.0848 11.0137 10.2635V10.2635Z"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export const ConferenceRoomBorderedIcon = ({
  color,
  width = 16,
  height = 16,
}: any) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 11.5H15.5V0.5H3.5V2M10.5 3V9M12.5 5V9M8.5 6V9M5 5.5C5 6.60457 4.10457 7.5 3 7.5C1.89543 7.5 1 6.60457 1 5.5C1 4.39543 1.89543 3.5 3 3.5C4.10457 3.5 5 4.39543 5 5.5ZM3 9.5C3.66304 9.5 4.29893 9.76339 4.76777 10.2322C5.23661 10.7011 5.5 11.337 5.5 12V15.5H0.5V12C0.5 11.337 0.763392 10.7011 1.23223 10.2322C1.70107 9.76339 2.33696 9.5 3 9.5Z"
      stroke="black"
    />
  </svg>
)

export const StandartOfficeBorderedIcon = ({
  color,
  width = 16,
  height = 16,
}: any) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.06 15.499V15.999H8.06V15.499H7.06ZM7.56 0.499023V-0.000976562H7.06V0.499023H7.56ZM15.56 0.499023H16.06V-0.000976562H15.56V0.499023ZM15.06 15.499V15.999H16.06V15.499H15.06ZM14 7.00024V6.50024H13V7.00024H14ZM13 9.77478V10.2748H14V9.77478H13ZM3.6788 7.07741L3.23074 6.85549L3.07074 7.17854L3.32669 7.43241L3.6788 7.07741ZM1.69647 7.07556L2.04881 7.43032L2.30554 7.17535L2.1436 6.85179L1.69647 7.07556ZM3.18724 10.162V9.66197H2.18724V10.162H3.18724ZM2.18724 11.9085V12.4085H3.18724V11.9085H2.18724ZM0.671924 12.0002V11.5002H0.0444461L0.184546 12.1119L0.671924 12.0002ZM4.64716 12.0002L5.13857 12.0925L5.24981 11.5002H4.64716V12.0002ZM3.99937 15.4492V15.9492H4.4142L4.49078 15.5415L3.99937 15.4492ZM1.46193 15.4492L0.974557 15.5608L1.06351 15.9492H1.46193V15.4492ZM15.5 16.0002H16V15.0002H15.5V16.0002ZM0.5 15.0002H0V16.0002H0.5V15.0002ZM8.06 15.499V0.499023H7.06V15.499H8.06ZM7.56 0.999023H15.56V-0.000976562H7.56V0.999023ZM15.06 0.499023V15.499H16.06V0.499023H15.06ZM13 7.00024V9.77478H14V7.00024H13ZM2.68724 5.4669C3.09027 5.4669 3.41255 5.79124 3.41255 6.18586H4.41255C4.41255 5.23406 3.63765 4.4669 2.68724 4.4669V5.4669ZM3.41255 6.18586C3.41255 6.35899 3.35236 6.60994 3.23074 6.85549L4.12685 7.29933C4.29929 6.95117 4.41255 6.54809 4.41255 6.18586H3.41255ZM3.32669 7.43241C3.62918 7.73243 3.82099 8.18546 3.82099 8.56961H4.82099C4.82099 7.90061 4.50936 7.19697 4.0309 6.72241L3.32669 7.43241ZM3.82099 8.56961C3.82099 9.18864 3.31585 9.69489 2.68724 9.69489V10.6949C3.86323 10.6949 4.82099 9.74581 4.82099 8.56961H3.82099ZM2.68724 9.69489C2.05864 9.69489 1.5535 9.18864 1.5535 8.56961H0.553498C0.553498 9.74581 1.51126 10.6949 2.68724 10.6949V9.69489ZM1.5535 8.56961C1.5535 8.18519 1.74561 7.73145 2.04881 7.43032L1.34413 6.7208C0.865674 7.19599 0.553498 7.9 0.553498 8.56961H1.5535ZM2.1436 6.85179C2.02193 6.60867 1.96193 6.35868 1.96193 6.18586H0.961935C0.961935 6.54781 1.07501 6.95099 1.24934 7.29933L2.1436 6.85179ZM1.96193 6.18586C1.96193 5.79124 2.28421 5.4669 2.68724 5.4669V4.4669C1.73683 4.4669 0.961935 5.23406 0.961935 6.18586H1.96193ZM2.18724 10.162V11.9085H3.18724V10.162H2.18724ZM0.671924 12.5002H4.64716V11.5002H0.671924V12.5002ZM4.15575 11.9079L3.50796 15.3569L4.49078 15.5415L5.13857 12.0925L4.15575 11.9079ZM3.99937 14.9492H1.46193V15.9492H3.99937V14.9492ZM1.94931 15.3376L1.1593 11.8886L0.184546 12.1119L0.974557 15.5608L1.94931 15.3376ZM15.5 15.0002H0.5V16.0002H15.5V15.0002Z"
      fill="black"
    />
  </svg>
)

export const CommunityBarBorderedIcon = ({
  color,
  width = 16,
  height = 16,
}: any) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.5 1C10.6716 1 10 1.67157 10 2.5C10 3.32843 10.6716 4 11.5 4C12.3284 4 13 3.32843 13 2.5C13 1.67157 12.3284 1 11.5 1ZM9 2.5C9 1.11929 10.1193 0 11.5 0C12.8807 0 14 1.11929 14 2.5C14 3.46056 13.4583 4.29459 12.6637 4.71324C13.7951 5.15769 14.5 6.24662 14.5 7.5C14.5 7.77614 14.2761 8 14 8C13.7239 8 13.5 7.77614 13.5 7.5C13.5 6.3795 12.7082 5.5 11.5 5.5C10.2918 5.5 9.5 6.3795 9.5 7.5C9.5 7.77614 9.27614 8 9 8C8.72386 8 8.5 7.77614 8.5 7.5C8.5 6.24662 9.20489 5.15769 10.3363 4.71324C9.54173 4.29459 9 3.46056 9 2.5ZM1.5 6.5C1.5 5.94772 1.94772 5.5 2.5 5.5H5.5C6.05228 5.5 6.5 5.94772 6.5 6.5V8.5H14.875H15.5C15.7761 8.5 16 8.72386 16 9C16 9.27614 15.7761 9.5 15.5 9.5H15.375V15.5C15.375 15.7761 15.1511 16 14.875 16C14.5989 16 14.375 15.7761 14.375 15.5V9.5H5.5H2.5H1.625V15.5C1.625 15.7761 1.40114 16 1.125 16C0.848858 16 0.625 15.7761 0.625 15.5V9.5H0.5C0.223858 9.5 0 9.27614 0 9C0 8.72386 0.223858 8.5 0.5 8.5H1.125H1.5V6.5ZM5.5 6.5H2.5V8.5H5.5V6.5ZM3 12C3 11.7239 3.22386 11.5 3.5 11.5H12.5C12.7761 11.5 13 11.7239 13 12C13 12.2761 12.7761 12.5 12.5 12.5H3.5C3.22386 12.5 3 12.2761 3 12ZM3 15C3 14.7239 3.22386 14.5 3.5 14.5H12.5C12.7761 14.5 13 14.7239 13 15C13 15.2761 12.7761 15.5 12.5 15.5H3.5C3.22386 15.5 3 15.2761 3 15Z"
      fill="black"
    />
  </svg>
)

export const OfficeBorderedIcon = ({ color, width = 16, height = 16 }: any) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.06 15.499V15.999H8.06V15.499H7.06ZM7.56 0.499023V-0.000976562H7.06V0.499023H7.56ZM15.56 0.499023H16.06V-0.000976562H15.56V0.499023ZM15.06 15.499V15.999H16.06V15.499H15.06ZM14 7.00024V6.50024H13V7.00024H14ZM13 9.77478V10.2748H14V9.77478H13ZM3.6788 7.07741L3.23074 6.85549L3.07074 7.17854L3.32669 7.43241L3.6788 7.07741ZM1.69647 7.07556L2.04881 7.43032L2.30554 7.17535L2.1436 6.85179L1.69647 7.07556ZM3.18724 10.162V9.66197H2.18724V10.162H3.18724ZM2.18724 11.9085V12.4085H3.18724V11.9085H2.18724ZM0.671924 12.0002V11.5002H0.0444461L0.184546 12.1119L0.671924 12.0002ZM4.64716 12.0002L5.13857 12.0925L5.24981 11.5002H4.64716V12.0002ZM3.99937 15.4492V15.9492H4.4142L4.49078 15.5415L3.99937 15.4492ZM1.46193 15.4492L0.974557 15.5608L1.06351 15.9492H1.46193V15.4492ZM15.5 16.0002H16V15.0002H15.5V16.0002ZM0.5 15.0002H0V16.0002H0.5V15.0002ZM8.06 15.499V0.499023H7.06V15.499H8.06ZM7.56 0.999023H15.56V-0.000976562H7.56V0.999023ZM15.06 0.499023V15.499H16.06V0.499023H15.06ZM13 7.00024V9.77478H14V7.00024H13ZM2.68724 5.4669C3.09027 5.4669 3.41255 5.79124 3.41255 6.18586H4.41255C4.41255 5.23406 3.63765 4.4669 2.68724 4.4669V5.4669ZM3.41255 6.18586C3.41255 6.35899 3.35236 6.60994 3.23074 6.85549L4.12685 7.29933C4.29929 6.95117 4.41255 6.54809 4.41255 6.18586H3.41255ZM3.32669 7.43241C3.62918 7.73243 3.82099 8.18546 3.82099 8.56961H4.82099C4.82099 7.90061 4.50936 7.19697 4.0309 6.72241L3.32669 7.43241ZM3.82099 8.56961C3.82099 9.18864 3.31585 9.69489 2.68724 9.69489V10.6949C3.86323 10.6949 4.82099 9.74581 4.82099 8.56961H3.82099ZM2.68724 9.69489C2.05864 9.69489 1.5535 9.18864 1.5535 8.56961H0.553498C0.553498 9.74581 1.51126 10.6949 2.68724 10.6949V9.69489ZM1.5535 8.56961C1.5535 8.18519 1.74561 7.73145 2.04881 7.43032L1.34413 6.7208C0.865674 7.19599 0.553498 7.9 0.553498 8.56961H1.5535ZM2.1436 6.85179C2.02193 6.60867 1.96193 6.35868 1.96193 6.18586H0.961935C0.961935 6.54781 1.07501 6.95099 1.24934 7.29933L2.1436 6.85179ZM1.96193 6.18586C1.96193 5.79124 2.28421 5.4669 2.68724 5.4669V4.4669C1.73683 4.4669 0.961935 5.23406 0.961935 6.18586H1.96193ZM2.18724 10.162V11.9085H3.18724V10.162H2.18724ZM0.671924 12.5002H4.64716V11.5002H0.671924V12.5002ZM4.15575 11.9079L3.50796 15.3569L4.49078 15.5415L5.13857 12.0925L4.15575 11.9079ZM3.99937 14.9492H1.46193V15.9492H3.99937V14.9492ZM1.94931 15.3376L1.1593 11.8886L0.184546 12.1119L0.974557 15.5608L1.94931 15.3376ZM15.5 15.0002H0.5V16.0002H15.5V15.0002Z"
      fill="black"
    />
  </svg>
)

export const CheckIcon = ({ color, width = 16, height = 16 }: any) => (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 4.2L3.4 6.6L9 1" stroke="#0077CC" stroke-width="1.5" />
  </svg>
)

export const ImgIcon = ({ color, width = 16, height = 16 }: any) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 12.5L4 9.5L6 11.5L11 6.5L16 11.5M14.5 15.5H2.5C2.10218 15.5 1.72064 15.342 1.43934 15.0607C1.15804 14.7794 1 14.3978 1 14V2C1 1.60218 1.15804 1.22064 1.43934 0.93934C1.72064 0.658035 2.10218 0.5 2.5 0.5H14.5C14.8978 0.5 15.2794 0.658035 15.5607 0.93934C15.842 1.22064 16 1.60218 16 2V14C16 14.3978 15.842 14.7794 15.5607 15.0607C15.2794 15.342 14.8978 15.5 14.5 15.5ZM7 5C7 5.82843 6.32843 6.5 5.5 6.5C4.67157 6.5 4 5.82843 4 5C4 4.17157 4.67157 3.5 5.5 3.5C6.32843 3.5 7 4.17157 7 5Z"
      stroke="#666666"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
